export default __webpack_public_path__ + "assets/images/35dbdc36aee7634b8a3cba6728615089.svg";